import Lenis from "lenis";

let lenis = null;
let rafId = null;

export function initLenis() {
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
        cancelAnimationFrame(rafId);
        lenis?.destroy();
        lenis = null;
    };
}

export function scrollTo(target) {
    if (lenis) {
        lenis.scrollTo(target, {
            offset: -64,
            duration: 1.4,
            easing: (t) => 1 - Math.pow(1 - t, 3),
        });
    } else {
        document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    }
}
